
import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';
import { HeroBackground } from './HeroBackground';
import { HeroContent } from './HeroContent';
import { HeroFeatures } from './HeroFeatures';
import { HeroScrollIndicator } from './HeroScrollIndicator';

export const PremiumHero = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const isMobile = useIsMobile();
  const { scrollY } = useScroll();
  
  const parallaxY = useTransform(scrollY, [0, 500], [0, -100]);
  const parallaxOpacity = useTransform(scrollY, [0, 300], [1, 0]);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };

    if (!isMobile) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      if (!isMobile) {
        window.removeEventListener('mousemove', handleMouseMove);
      }
    };
  }, [isMobile]);

  return (
    <motion.section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 md:pt-32"
      style={{ y: parallaxY, opacity: parallaxOpacity }}
    >
      <HeroBackground mousePosition={mousePosition} isMobile={isMobile} />

      <div className="container mx-auto px-4 relative z-20">
        <div className="max-w-6xl mx-auto text-center">
          <HeroContent isMobile={isMobile} />
          <HeroFeatures />
          <HeroScrollIndicator />
        </div>
      </div>
    </motion.section>
  );
};

export default PremiumHero;
